module.exports = __webpack_public_path__ + "static/media/abbysigler.33052f25.jpeg";